/**
 * @name TabSystem
 * @description
 * Helper class for uib-tabset component. It registers tabs and set {@link TabSystem.activeTabId} property in depending of tab index priority.
 *
 * @example
 * ```
 * <uib-tabset active="$ctrl.tabSystem.activeTabId">
 *     <uib-tab index="'FIRST'" ng-init="$ctrl.tabSystem.registerTab('FIRST')">FIRST</uib-tab>
 *     <uib-tab index="'SECOND'" ng-init="$ctrl.tabSystem.registerTab('SECOND')">SECOND</uib-tab>
 * </uib-tabset>
 *
 * <script>
 *     const PRIORITIES: TabSystemPriorities = {
 *         FIRST: 100,
 *         SECOND: 200
 *     };
 *     $ctrl.tabSystem = new TabSystem(PRIORITIES);
 * </script>
 *```
 * Tab second has higher priority then tab FIRST, so it will be set by default as active.
 */
export default class TabSystem {
    public activeTabId: string;

    constructor(private priorities: TabSystemPriorities) {
    }

    public registerTab(tabId: string) {
        const tabPriority = this.priorities[tabId];
        const activeTab = this.priorities[this.activeTabId];

        if (!activeTab || tabPriority > activeTab) {
            this.activeTabId = tabId;
        }
    }
}

export interface TabSystemPriorities {
    [priority: string]: number;
}
